/**
 * Can be used to add listener for keyboard accessibility
 * when instead of click event mousedown event is used
 */
export const onKeyboardClick = (callback) => (e) => {
  if (e.key === ' ' || e.key === 'Enter') {
    callback(e);
  }
};
